export default "__VITE_ASSET__UQhcdqVx__"